import { NgModule } from '@angular/core';
import { OfferToggleComponent } from './offer-toggle.component';
import { SharedModule } from '../@shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    declarations: [OfferToggleComponent],
    imports: [SharedModule, CommonModule, MatSidenavModule],
    exports: [OfferToggleComponent],
})
export class OfferToggleModule {}
